import React, {Component} from 'react';
import {connect} from 'react-redux';
import Preloader from 'components/molecules/preloader';
import LineupsDashboard from 'components/organisms/lineups-dashboard';
import {ExposureBox} from 'components/organisms/exposure-box';
import {LineupsList} from 'components/organisms/lineups-list';

class Lineups extends Component {
    render() {
        const {isLineupsLoaded} = this.props;

        if (!isLineupsLoaded) {
            return <Preloader />;
        }

        return (
            <div>
                <div className="white-box">
                    <LineupsDashboard />
                </div>
                <div className="results-wrap">
                    <ExposureBox />
                    <LineupsList />
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {lineups} = state.lineupsData;

    return {
        isLineupsLoaded: lineups.loaded,
    };
}

export default connect(mapStatesToProps)(Lineups);
